import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "@mui/material";
import { theme } from "./components/ui/theme";
import { LoaderProvider } from "./context/loaderContext";
import { MessageDialogProvider } from "./context/MessageDialogContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <LoaderProvider>
      <MessageDialogProvider>
      <App />
      </MessageDialogProvider>
    </LoaderProvider>
  </ThemeProvider>
  // </React.StrictMode>
);
